import { PrivacyLevel } from '../PrivacyLevel';

export default class GroupFinanceSettings {
    public applyMissingAttributionsOnTransfer: boolean = false;
    public autoDistributeIncomeToSavings: boolean = false;
    public autoDistributeExpensesToSavings: boolean = false;
    public privacyLevel: PrivacyLevel = PrivacyLevel.Unknown;
}
